import {action} from "mobx";
import i18n from "../i18n";
import ticketService from "../services/ticketService";
import appStore from "./appStore";

// Talep oluşturma mesajı uzun olduğundan tamamının okunabilmesi için daha uzun süre gösterilir
const CREATED_MESSAGE_DURATION_SECONDS = 5;

const unwrap = (resultOfRequest, successKey, duration) => {
    if (resultOfRequest.status !== 200) {
        appStore.openErrorModal({content: resultOfRequest.data.message});
        return false;
    }
    if (successKey) {
        appStore.showSuccessMessage({content: i18n.t(successKey, {ns: "tickets"}), duration});
    }
    return resultOfRequest.data;
};

class ticketStore {
    @action getTicketOptions = async () => unwrap(await ticketService.getTicketOptions());

    @action getTickets = async params => unwrap(await ticketService.getTickets(params));

    @action getTicketCounts = async params => unwrap(await ticketService.getTicketCounts(params));

    @action exportTickets = async params => unwrap(await ticketService.exportTickets(params));

    @action getTicket = async id => unwrap(await ticketService.getTicket(id));

    @action getAssignableUsers = async (role, ticketId, search) =>
        unwrap(await ticketService.getAssignableUsers(role, ticketId, search));

    @action uploadTicketPhoto = async params =>
        unwrap(await ticketService.uploadTicketPhoto(params));

    @action createTicket = async params =>
        unwrap(
            await ticketService.createTicket(params),
            "messages.created",
            CREATED_MESSAGE_DURATION_SECONDS
        );

    @action claimTicket = async id =>
        unwrap(await ticketService.claimTicket(id), "messages.claimed");

    @action assignTicket = async (id, params) =>
        unwrap(await ticketService.assignTicket(id, params), "messages.assigned");

    @action changeTicketPriority = async (id, params) =>
        unwrap(await ticketService.changeTicketPriority(id, params), "messages.priorityChanged");

    @action changeTicketVisibility = async (id, params) =>
        unwrap(
            await ticketService.changeTicketVisibility(id, params),
            "messages.visibilityChanged"
        );

    @action addTicketNote = async (id, params) =>
        unwrap(await ticketService.addTicketNote(id, params), "messages.noteAdded");

    @action closeTicket = async (id, params) =>
        unwrap(await ticketService.closeTicket(id, params), "messages.closed");

    @action cancelTicket = async (id, params) =>
        unwrap(await ticketService.cancelTicket(id, params), "messages.cancelled");

    @action deleteTicket = async id =>
        unwrap(await ticketService.deleteTicket(id), "messages.deleted");
}

export default new ticketStore();
